import { render, staticRenderFns } from "./LawAuthorityForm.vue?vue&type=template&id=496b9c3f&"
import script from "./LawAuthorityForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityForm.vue?vue&type=style&index=0&id=496b9c3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports